import { UAParser } from 'ua-parser-js'

import { isVersionLower } from '#ui/app/utils/version'

import { BROWSER_SUPPORT_MATRIX } from './browserSupportMatrix'

const ENGINE_MIN_VERSIONS: Record<string, string> = {
  Blink: BROWSER_SUPPORT_MATRIX.chrome,
  Gecko: BROWSER_SUPPORT_MATRIX.firefox,
  WebKit: '537.36.0',
}

const convertToSemver = (version: string) => {
  const segments = version.split('.')
  while (segments.length < 3) {
    segments.push('0')
  }
  return segments.slice(0, 3).join('.')
}

export const isLegacyBrowser = (ua: string) => {
  try {
    const parser = new UAParser(ua)
    const { browser, engine, os } = parser.getResult()

    // Every iOS browser runs the system WebKit, so the OS version is all that matters there.
    if (os.name === 'iOS' && os.version) {
      return isVersionLower(convertToSemver(os.version), BROWSER_SUPPORT_MATRIX.ios)
    }

    // Safari freezes the macOS version in its UA at 10_15_7, so a passing OS doesn't settle it --
    // the browser version is still checked below.
    if (
      os.name === 'macOS' &&
      os.version &&
      isVersionLower(convertToSemver(os.version), BROWSER_SUPPORT_MATRIX.macos)
    ) {
      return true
    }

    // Browser specific check
    switch (browser.name) {
      case 'Chrome':
      case 'Mobile Chrome':
        if (browser.version) {
          const isLegacy = isVersionLower(
            convertToSemver(browser.version),
            BROWSER_SUPPORT_MATRIX.chrome,
          )
          return isLegacy
        }
        break
      case 'Firefox':
        if (browser.version)
          return isVersionLower(convertToSemver(browser.version), BROWSER_SUPPORT_MATRIX.firefox)
        break
      case 'Mobile Safari':
        if (browser.version)
          return isVersionLower(convertToSemver(browser.version), BROWSER_SUPPORT_MATRIX.ios)
        break
      case 'Safari':
        if (browser.version)
          return isVersionLower(convertToSemver(browser.version), BROWSER_SUPPORT_MATRIX.safari)
        break
    }

    // Engine-based fallback
    if (engine?.name && browser?.version) {
      const minVersion = ENGINE_MIN_VERSIONS[engine.name]
      if (minVersion) {
        return isVersionLower(convertToSemver(browser.version), minVersion)
      }
    }

    // iOS Native App
    const isNativeApp = (ua.match(/Lottocom_app/) || [])[0]
    if (isNativeApp) {
      const iOSVersion = (ua.match(/iOS;\s*([\d.]+)/) || [])[1]

      if (iOSVersion) {
        return isVersionLower(convertToSemver(iOSVersion), BROWSER_SUPPORT_MATRIX.ios)
      }
    }
  } catch (e) {
    console.error(e)
  }

  return false
}
